import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

type ActivityPoint = {
  date: string;
  chats_started: number;
  journals_completed: number;
};

type Props = {
  data: ActivityPoint[];
  height?: number;
};

export function ActivityTrendChart({ data, height = 200 }: Props) {
  return (
    <div className="h-full w-full">
      <ResponsiveContainer width="100%" height={height}>
        <AreaChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorChats" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#06b6d4" stopOpacity={0.35} />
              <stop offset="95%" stopColor="#06b6d4" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="colorJournals" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#22c55e" stopOpacity={0.35} />
              <stop offset="95%" stopColor="#22c55e" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#334155" vertical={false} />
          <XAxis
            dataKey="date"
            stroke="#94a3b8"
            fontSize={11}
            tickLine={false}
            axisLine={false}
            minTickGap={20}
          />
          <YAxis stroke="#94a3b8" fontSize={11} tickLine={false} axisLine={false} width={28} />
          <Tooltip contentStyle={{ backgroundColor: '#0f172a', borderColor: '#334155', color: '#e2e8f0' }} />
          <Area
            type="monotone"
            dataKey="chats_started"
            name="Chat iniziate"
            stroke="#06b6d4"
            fill="url(#colorChats)"
            strokeWidth={2}
            dot={false}
          />
          <Area
            type="monotone"
            dataKey="journals_completed"
            name="Diari conclusi"
            stroke="#22c55e"
            fill="url(#colorJournals)"
            strokeWidth={2}
            dot={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
